
{/*full file added by dev-Ayush 03/12/2024 , whatsapp service */}
const styles = theme => ({

    campaignText: {
        color: '#FFF ! important',
        fontFamily: 'cardiuma-M ! important',
        fontSize: '34px ! important',
        fontStyle: 'normal',
        fontWeight: '500 ! important',
        lineHeight: '20px ! important'
    },

    grid1 : {
        marginTop : "30px !important",
        display : "flex",
        justifyContent : "center",
        width : "100% !important",
        gap : "20px !important"
    },

    button : {
        width: "150px !important",
        height: "48px !important",
        padding: "8px 24px !important",
        gap: "10px !important",
        color: "rgb(255, 255, 255) !important",
        backgroundColor: "rgb(244, 71, 72) !important",
        fontFamily: "cardiuma-regular !important",
        fontSize: "11px !important",
        fontStyle: "normal !important",
        marginTop : "5px !important"
    },
    chooseButton: {
        width: "210px !important",
        height: '50px !important',
        backgroundColor: 'rgb(244, 71, 72) !important'
    },

    info : {
        marginLeft : "5px !important",
        marginTop : "5px !important",
        color : "#F3D45E !important",
        fontSize : "12px !important"
    },
    info1 : {
        marginLeft : "5px !important",
        marginTop : "30px !important",
        color : "#F3D45E !important",
        fontSize : "18px !important"
    },
    reTest : {
        width: "100px !important",
        height: "20px !important",
        gap: "10px !important",
        color: "#ffffff !important",
        backgroundColor: "#1976d2 !important",
        fontFamily: "cardiuma-regular !important",
        fontSize: "11px !important",
        fontStyle: "normal !important",
        marginTop : "5px !important"
    }
})

export default styles
